const CardData = [
  {
    icon: "/assets/softwareDev/img1.svg",
    heading: "Enterprise Software Solutions",
    paragraph:
      "Large team? Complex workflows? We design scalable systems that simplify operations and bring clarity to your day-to-day.",
  },
  {
    icon: "/assets/softwareDev/img2.svg",
    heading: "Enterprise Software Solutions",
    paragraph:
      "Large team? Complex workflows? We design scalable systems that simplify operations and bring clarity to your day-to-day.",
  },
  {
    icon: "/assets/softwareDev/img3.svg",
    heading: "SaaS Platforms",
    paragraph:
      "Launching a new product or platform? We’ve helped startups and scale-ups create SaaS products that are secure, cloud-ready, and loved by users.",
  },
  {
    icon: "/assets/softwareDev/img4.svg",
    heading: "API Development & Integration",
    paragraph:
      "Your systems should talk to each other. We build and connect APIs so your tools can work together, smoothly and efficiently.",
  },
];

const ProcessData = [
  {
    topic: "Discover",
    description:
      "We listen, ask questions, and understand what you really need.",
  },
  {
    topic: "Design",
    description:
      "User-first, future-ready designs that balance beauty with usability.",
  },
  {
    topic: "Develop",
    description:
      "Agile development with full transparency and regular updates.",
  },
  {
    topic: "Test",
    description: "No bugs. Just smooth, secure performance.",
  },
  {
    topic: "Launch & Support",
    description: "We help you go live and stick around to support you after.",
  },
];

const BusinessData1 = [
  {
    icon: "/assets/softwareDev/icon1.svg",
    title: "REACT",
  },
  {
    icon: "/assets/softwareDev/icon2.svg",
    title: "NODE.JS",
  },
  {
    icon: "/assets/softwareDev/icon3.svg",
    title: "FLUTTER",
  },
  {
    icon: "/assets/softwareDev/icon4.svg",
    title: "PYTHON",
  },
  {
    icon: "/assets/softwareDev/icon5.svg",
    title: ".NET",
  },
];

const BusinessData2 = [
  {
    icon: "/assets/softwareDev/icon6.svg",
    title: "MONGODB",
  },
  {
    icon: "/assets/softwareDev/icon7.png",
    title: "POSTGRESQL",
  },
  {
    icon: "/assets/softwareDev/icon8.svg",
    title: "AWS",
  },
  {
    icon: "/assets/softwareDev/icon9.svg",
    title: "AZURE",
  },
];

export { CardData, ProcessData, BusinessData1, BusinessData2 };
